import { Text } from 'theme-ui'
import Box from '/components/Commons/Box'

import styles from './styles'

const TextBanner = ({ cmsContent }) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.titleContainer}>
        <Text as="h2">{cmsContent?.titleSection}</Text>
      </Box>
      <Box sx={styles.textSection}>
        <Box sx={styles.subtitleContainer}>
          <Text as="h3">{cmsContent?.subtitle}</Text>
        </Box>
        <Box sx={styles.description}>
          <Text as="p">{cmsContent?.description}</Text>
        </Box>
      </Box>
    </Box>
  )
}

export default TextBanner
